export default "__VITE_ASSET__BhRD92yZ__"